<template>
  <b-dropdown
    variant="primary"
    size="sm"
    text="Templates"
  >
    <b-dropdown-form>
      <b-list-group flush>
        <b-list-group-item>
          <b-form-checkbox
            v-model="isSelectedAllTemplate"
            size="sm"
            @change="toggleSelectAll"
          >
            Select All
          </b-form-checkbox>
        </b-list-group-item>
        <b-list-group-item
          v-for="instance in instances"
          :key="instance.id"
        >
          <b-form-checkbox
            v-model="instance.selected"
            size="sm"
            :disabled="instance.id === selectedInstance.id"
          >
            {{ getInstanceName(instance.id) }}
          </b-form-checkbox>
        </b-list-group-item>
      </b-list-group>
      <b-dropdown-form />
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('layout');

export default {
  name: 'PreviewsDropdown',
  data() {
    return {
      instances: [],
      isSelectedAllTemplate: false
    };
  },
  computed: {
    ...mapGetters([
      'selectedInstance'
    ]),
    selected() {
      return this.instances.filter(instance => instance.selected).map(instance => instance.id);
    },
    previews() {
      return window.previews || [];
    }
  },
  watch: {
    instances: {
      deep: true,
      handler() {
        this.$emit(
          'input',
          this.instances
            .filter(instance => instance.selected)
            .map(instance => instance.id)
        );

        this.isSelectedAllTemplate = this.instances.every(instance => instance.selected);
      }
    },
    selectedInstance() {
      this.initInstances();
    },
    previews() {
      this.initInstances();
    }
  },
  mounted() {
    this.initInstances();
  },
  methods: {
    initInstances() {
      this.instances = this.previews.map(preview => ({
        id: preview.id,
        selected: this.selectedInstance.id === preview.id,
      }));
    },
    toggleSelectAll() {
      this.instances = this.instances.map(instance => ({
        ...instance,
        selected: this.isSelectedAllTemplate || this.selectedInstance.id === instance.id
      }));
    },
    getInstanceName(instanceId) {
      const instance = this.previews.find(preview => preview.id === instanceId);

      if (!instance) {
        return '';
      }

      return instance.template.name;
    }
  }
};
</script>
